"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlanFrequency = exports.PlanTypes = exports.SalesStatus = exports.CartActions = exports.AlertTypes = exports.WirelessConstants = void 0;
// import * as icons from '../styles/att-icons-wireless.scss';
var icons = require("../styles/att-icons-wireless.scss");
var DeviceLineProps_1 = require("../components/DeviceCountPanel/DeviceLine/DeviceLineProps");
/**
 * WirelessConstants Component defines constants needed for the Buy Flow/CRP flow.
 *
 * @export
 * @class WirelessConstants
 *
 */
var WirelessConstants = /** @class */ (function () {
    function WirelessConstants() {
    }
    WirelessConstants.WIRELESS_NAMESPACE = 'WIRELESS';
    WirelessConstants.APPSHELL_NAMESPACE = 'appShell';
    WirelessConstants.CHECKOUT_NAMESPACE = 'CHECKOUT';
    WirelessConstants.APPSHELL_WIRELESS_CATALOG_RESPONSE_KEY = 'catalogResponse';
    WirelessConstants.APPSHELL_WIRELESS_INTENT = 'IDSEIntent';
    WirelessConstants.APPSHELL_WIRELESS_PPO_INTENT = 'ppo';
    WirelessConstants.APPSHELL_WIRELESS_AUTH_DETAILS = 'wlsAuthDetails';
    WirelessConstants.APPSHELL_CART_RESPONSE_KEY = 'cartResponse';
    WirelessConstants.APPSHELL_GO_TO_CART_CLICKED = 'goToCartClicked';
    WirelessConstants.WIRELESS_FLOW_TYPE_CHANGE_PLAN = 'changeplan';
    WirelessConstants.ENJOY_ELIGIBLE_RESPONSE_KEY = 'enjoyEligibleSku';
    WirelessConstants.WIRELESS_DEVICE_DETAIL_RESPONSE_KEY = 'deviceDetailResponse';
    WirelessConstants.WIRELESS_DEVICES_DETAIL_RESPONSE_KEY = 'devicesDetailResponse';
    WirelessConstants.WIRELESS_TARGET_DEVICES_DETAIL_RESPONSE_KEY = 'targetDevicesDetailResponse';
    WirelessConstants.WIRELESS_DELIVERY_PROMISE_RESPONSE_KEY = 'deliveryPromiseResponse';
    WirelessConstants.WIRELESS_DEVICE_ACTION_TYPE = 'deviceActionType';
    WirelessConstants.WIRELESS_CART_RESPONSE_KEY = 'cartResponse';
    WirelessConstants.WIRELESS_HARD_STOP_PAGE = 'hardStopPage';
    WirelessConstants.WIRELESS_DEVICE_ADDED_TO_CART_KEY = 'deviceAddedToCart';
    WirelessConstants.WIRELESS_CART_ACTIONS_KEY = 'cartActions';
    WirelessConstants.WIRELESS_GET_PLANS_RESPONSE = 'getPlansResponse';
    WirelessConstants.WIRELESS_EAP_FLOW = 'eapInCart';
    WirelessConstants.WIRELESS_EXIST_PLAN_TYPE_JG = 'existJGPlan';
    WirelessConstants.WIRELESS_PLAN_IN_CART_KEY = 'planInCart';
    WirelessConstants.WIRELESS_INSURANCE_IN_CART_KEY = 'insuranceInCart';
    WirelessConstants.WIRELESS_PRICE_BAR_UPDATE_KEY = 'priceBarUpdate';
    WirelessConstants.WIRELESS_ACCOUNT_FEATURE_DETAILS_RESPONSE_KEY = 'accountFeatureDetailsResponse';
    WirelessConstants.WIRELESS_PICK_SOMETHING_ELSE = 'pickSomethingElse';
    // Will update it once we get feature toggle configuration from app-shell.
    WirelessConstants.WIRELESS_PDP_CONTENT_CACHE = 'pdpcontentcache';
    WirelessConstants.WIRELESS_FAN_PROFILE_KEY = 'fanProfile';
    WirelessConstants.WIRELESS_FEATURE_TOGGLE_KEY = 'featureToggle';
    WirelessConstants.WIRELESS_DEVICE_CMS_MAPPING = 'deviceToContent';
    WirelessConstants.WIRELESS_URL_KEY = 'baseURL';
    WirelessConstants.WIRELESS_DETAILS = 'wirelessDetails';
    WirelessConstants.WIRELESS_OFFER_TARGET = 'offerTarget';
    WirelessConstants.WIRELESS_PROMO_OFFER_KEY = 'offerID';
    WirelessConstants.WIRELESS_PROMO_TEMP_OFFER = 'tempUpsell';
    WirelessConstants.WIRELESS_PROMO_STORAGE = 'upSell';
    WirelessConstants.WIRELESS_PROMO_TEMP_OFFER_LIST = 'tempUpsellList';
    WirelessConstants.WIRELESS_PICKSOMETHING_ELSE_OFFER_LIST = 'tempPromoOffersList';
    WirelessConstants.WIRELESS_PROMO_MAPPING = 'upSellMapping';
    WirelessConstants.WIRELESS_NEXT_PAGEVIEW = 'nextPageView';
    WirelessConstants.WIRELESS_REMOVE_DATAPLAN = 'CHECK_FOR_REMOVE_DATAPLAN';
    WirelessConstants.WIRELESS_REMOVE_DEVICE_WITH_MOBILESHAREPLAN = 'CHECK_FOR_REMOVE_DEVCIE_MOBILESHARE_PLAN_ONLY_TABLET_IN_CART';
    WirelessConstants.WIRELESS_HYLA_TRADEIN = 'hylaTradeIn';
    WirelessConstants.WIRELESS_TRADEIN_INTENT = 'tradeInIntent';
    WirelessConstants.WIRELESS_PORTIN_INTENT = 'portInIntent';
    WirelessConstants.WIRELESS_TRADEIN_INTENT_PDP = 'tradeInIntentPDP';
    WirelessConstants.WIRELESS_PORTIN_INTENT_PDP = 'portInIntentPDP';
    WirelessConstants.WIRELESS_PORTIN_ONLY = 'portinOnly';
    WirelessConstants.WIRELESS_PROMO_BYPASS = 'byPassInst';
    WirelessConstants.WIRELESS_PROMOTIONS_LEGAL_KEY = 'promoLegalContent';
    WirelessConstants.WIRELESS_DEVICE_VIEW_TYPE_KEY = 'deviceViewType';
    WirelessConstants.WIRELESS_DISPLAY_STATE = 'wirelessDisplayState';
    WirelessConstants.WIRELESS_PROGRESSIVE_STEPS = 'progressiveSteps';
    WirelessConstants.WIRELESS_UPDATE_DEVICE_PANEL = 'wirelessUpdateDevicePanel';
    WirelessConstants.WIRELESS_FULL_CART = 'cartSummary';
    WirelessConstants.WIRELESS_GNSESS_COOKIE_INFO = 'GNSESS_COOKIE_INFO';
    WirelessConstants.WIRELESS_INTENDED_DEVICES = 'intendedDevices';
    WirelessConstants.WIRELESS_INTENDED_COMPLETE = 'intendedComplete';
    WirelessConstants.WIRELESS_SELECTED_DEVICE_TYPE_FILTER = 'selectedDeviceTypeFilter';
    WirelessConstants.WIRELESS_SELECTED_DEVICE_TYPE_FILTER_NAME = 'selectedDeviceTypeFilterName';
    WirelessConstants.WIRELESS_RETAINED_DEVICE_TYPE_FILTER = 'retainedDeviceTypeFilter';
    WirelessConstants.WIRELESS_SELECTED_DEVICE_FILTER = 'selectedDeviceFilter';
    WirelessConstants.WIRELESS_DEVICE_TYPE_FILTER = 'DEVICE_TYPE_FILTER';
    WirelessConstants.WIRELESS_DEVICE_MFT_FILTER = 'MFT_FILTER';
    WirelessConstants.WIRELESS_DEVICE_FILTER_CONDITION = 'CONDITION_FILTER';
    WirelessConstants.WIRELESS_DEVICE_DEFAULT_SORT_FILTER = 'DFT_SORT_FILTER';
    WirelessConstants.WIRELESS_HIDE_BYOD_CARD = 'hideBYODCard';
    WirelessConstants.WIRELESS_SELECTED_LINE = 'selectedUpLine';
    WirelessConstants.WIRELESS_SELECTED_UPGRADE_OPTION = 'selectedUpgradeOption';
    WirelessConstants.WIRELESS_LOSG_HAS_FEATURE = 'losgFeatureInfo';
    WirelessConstants.WIRELESS_SELECTED_DEVICE_SKU = 'selectedDeviceSku';
    WirelessConstants.WIRELESS_DEVICE_CONFIG = 'deviceConfig';
    WirelessConstants.WIRELESS_PLAN_FIRST_PLAN_PRICE = 'planFirstPlanPrice';
    WirelessConstants.WIRELESS_INITIAL_INTENDED_DEVICE_COUNT = 'initialIntendedDeviceCount';
    WirelessConstants.WIRELESS_PLANS_FIRST_RESPONSE = 'plansFirstResponse';
    WirelessConstants.WIRELESS_PLP_INTENT_DEVICE = 'plpIntentDevice';
    WirelessConstants.WIRELESS_PLP_INTENT_DEVICE_A2C = 'plpIntentDeviceA2C';
    WirelessConstants.WIRELESS_C2S_RADIUS = [5, 10, 15, 20, 30, 40, 50, 100, 200];
    WirelessConstants.WIRELESS_PREPAID_LEGAL_SHORT = "A \"Device Only\" purchase is for a device without voice or data service. " +
        "Service would need to be purchased and activated separately. ";
    WirelessConstants.WIRELESS_MODAL = 'modal';
    WirelessConstants.WIRELESS_MODAL_CLOSE = 'Close';
    WirelessConstants.WIRELESS_SHOW_BAU_PRICELEGAL = 'openBAUPriceLegalModal';
    WirelessConstants.WIRELESS_JSON_FORMAT = 'json';
    WirelessConstants.WIRELESS_PLAN_IN_CART = 'planInCart';
    WirelessConstants.WIRELESS_LINE_ITEMS = 'lineItems';
    WirelessConstants.WIRELESS_LOSG_CONSENT = 'losgConsent';
    WirelessConstants.WIRELESS_SELECTED_TRADEIN_OFFER = '';
    WirelessConstants.WIRELESS_DEVICE_SELECTED = 'deviceSelected';
    WirelessConstants.WIRELESS_NEW_UPSELL_CART_API = 'newUpSellCartApi';
    WirelessConstants.WIRELESS_SELECTED_DEVICE_FOR_UPSELL = 'selectedDeviceForUpsell';
    WirelessConstants.UPSELL_CUSTOMIZE_OFFER = 'CustomizeOffer';
    WirelessConstants.TIMER_SKU_MAP = 'timerSkuMap';
    WirelessConstants.SUBSCRIBER_COUNT = [
        'one',
        'two',
        'three',
        'four',
        'five',
        'six',
        'seven',
        'eight',
        'nine',
        'ten',
        'eleven',
    ];
    WirelessConstants.WIRELESS_DEVICE_DISPLAY = 'Device';
    WirelessConstants.WIRELESS_UPSELLPAGEDETAILS = 'upSellPageDetails';
    WirelessConstants.WIRELESS_DEVICE = 'DEVICE';
    WirelessConstants.WIRELESS_PLAN_DISPLAY = 'Plan';
    WirelessConstants.WIRELESS_PLAN = 'sharedDataGroup';
    WirelessConstants.WIRELESS_PREPAID_PLAN = 'VOICEPLAN';
    WirelessConstants.WIRELESS_PREPAID_ACCESSORY = 'ACCESSORY';
    WirelessConstants.WIRELESS_ANNUAL_PLAN_TERM = 12;
    WirelessConstants.CURRENT_CONTEXT = 'currentcontext';
    WirelessConstants.WIRELESS_ACCOUNT_SUBSCRIBERS = 'subscriber';
    WirelessConstants.WIRELESS_DEVICE_COUNTS_CONFIG = 'deviceCountsConfig';
    WirelessConstants.WIRELESS_DEVICE_CARD_NAME_EXTRACT = '- AT&T';
    WirelessConstants.WIRELESS_RENDER_BYOD = 'renderBYOD';
    WirelessConstants.WIRELESS_REMOVE_LINK = 'Remove';
    WirelessConstants.WIRELESS_EMPTY_CART_EVENT = 'emptyCart';
    WirelessConstants.WIRELESS_EDIT_LINK_EVENT = 'editLinkUrl';
    WirelessConstants.WIRELESS_MAX_DEVICE_ALLOWED_TO_ADD = 5;
    WirelessConstants.WIRELESS_ACCESSORY_DETAIL_RESPONSE_KEY = 'accessoryDetailResponse';
    WirelessConstants.WIRELESS_ACCESSORY_CMS_MAPPING = 'accessoryToContent';
    WirelessConstants.WIRELESS_ACCESSORY_OFFER_RESPONSE = 'accessoryOfferResponse';
    WirelessConstants.WIRELESS_ACCESSORY_HOT_DEAL_OFFER_RESPONSE = 'accessoryHotDealOfferResponse';
    WirelessConstants.WIRELESS_AAL_FLOW = 'al|aal|alf';
    WirelessConstants.WIRELESS_UPGRADE_FLOW = 'up';
    WirelessConstants.WIRELESS_NEW_FLOW = 'new';
    WirelessConstants.WIRELESS_EAP_AL_NEW_FLOW = 'al';
    WirelessConstants.WIRELESS_EAP_DATA = 'eapData';
    WirelessConstants.WIRELESS_LNP_DATA = 'lnpData';
    WirelessConstants.WIRELESS_EAP_PRODUCT_TYPE = 'EAP Postpaid Coam';
    WirelessConstants.WIRELESS_EAP_CCAR_TYPE = 'EAP Postpaid Connected Car';
    WirelessConstants.WIRELESS_EAP_ON_DEVICE_PRODUCT_TYPE = 'EAP Postpaid On Device';
    WirelessConstants.WIRELESS_AL_CONFLICT_MODAL = 'displayConflictModal';
    WirelessConstants.WIRELESS_RESET_CONFLICT = 'resetPlans';
    WirelessConstants.WIRELESS_VENDOR_INSURANCE = 'vendorInsMap';
    WirelessConstants.WIRELESS_VENDOR_BYPASS_INSURANCE = 'vendorBypassInsurance';
    WirelessConstants.WIRELESS_IDSE_FLOW_SELECTED = 'IDSEFlowSelected';
    WirelessConstants.WIRELESS_ADD_ANOTHER_DEVICE = 'addAnotherDevice';
    WirelessConstants.WIRELESS_UPGRADE_CAROUSEL_STEP = 'upgradeCarouselStep';
    WirelessConstants.WIRELESS_PROMO_RICE = 'promoPrice';
    WirelessConstants.WIRELESS_DEVICE_IMPRESSION_INDEX = 'deviceImpressionIndex';
    WirelessConstants.WIRELESS_ACC_IMPRESSION_INDEX = 'accImpressionIndex';
    WirelessConstants.WIRELESS_LOSG_PHONENUMBERS = {};
    WirelessConstants.APPSHELL_WIRELESS_CUSTOMER_PROFILE_INFO = 'customerProfileInfo';
    WirelessConstants.WIRELESS_UPGRADE_DEVICE_CONTAINER_HIDE = 'hideDeviceContainer';
    WirelessConstants.WIRELESS_PRODUCT_SKU_KEY = 'wirelessProductSku';
    WirelessConstants.WIRELESS_REDIRECT_TO_PSC = '/buy/phones/universal-sim-card-bring-your-own-phone.html';
    WirelessConstants.WIRELESS_SET_TABLETS_AS_DEFAULT_FILTER = 'setTabletsAsDefaultFilter';
    //static SELECTED_TOGGLE_VALUE = 'SelectedToggleValue'
    WirelessConstants.PLP_TOGGLE = 'plp_trdIn';
    WirelessConstants.TRADEIN_PROMPTS = 'tradeInPromts';
    WirelessConstants.CHANGEDEVICE_LOSG = 'ChangeDeviceLosg';
    WirelessConstants.DEVICE_COUNTS = [
        {
            currentVal: 0,
            deviceType: "Phones" /* PHONES */,
            endIndex: WirelessConstants.WIRELESS_MAX_DEVICE_ALLOWED_TO_ADD,
            icon: DeviceLineProps_1.DeviceTypesStyleMap.get('PHONES'),
            startIndex: 0,
        },
        {
            currentVal: 0,
            deviceType: "Tablets" /* TABLETS */,
            endIndex: WirelessConstants.WIRELESS_MAX_DEVICE_ALLOWED_TO_ADD,
            icon: DeviceLineProps_1.DeviceTypesStyleMap.get('TABLETS'),
            startIndex: 0,
        },
        {
            currentVal: 0,
            deviceType: "Wearables" /* WEARABLES */,
            endIndex: WirelessConstants.WIRELESS_MAX_DEVICE_ALLOWED_TO_ADD,
            icon: DeviceLineProps_1.DeviceTypesStyleMap.get('WEARABLES'),
            startIndex: 0,
        },
    ];
    WirelessConstants.BYOD_FILTERS = [
        {
            iconClass: icons.attIconWireless + " " + icons.attIconWirelessMobilesmartphone,
            label: 'Phone',
            selected: true,
            sequence: 1,
            type: "Phones" /* PHONES */,
        },
        {
            iconClass: icons.attIconWireless + " " + icons.attIconWirelessTablet,
            label: 'Tablet',
            selected: false,
            sequence: 2,
            type: "Tablets" /* TABLETS */,
        },
        {
            iconClass: icons.attIconWireless + " " + icons.attIconWirelessWearables,
            label: 'Wearable',
            selected: false,
            sequence: 3,
            type: "Wearables" /* WEARABLES */,
        },
        {
            iconClass: icons.attIconWireless + " " + icons.attIconWirelessWearables,
            label: 'Hotspot',
            selected: false,
            sequence: 4,
            type: "Hotspots & more" /* HARMAN */,
        },
    ];
    WirelessConstants.WIRELESS_UPGRADE_NO_COMMIT_CONTRACT = 'NOCOMMIT';
    WirelessConstants.CONNECTED_CAR_ORDER_SRC = 'ordersrc';
    WirelessConstants.WIRELESS_FAN_DETAILS_RESPONSE = 'fanDetailsResponse';
    return WirelessConstants;
}());
exports.WirelessConstants = WirelessConstants;
var AlertTypes;
(function (AlertTypes) {
    AlertTypes["BUSINESS_ERROR"] = "BUSINESS_ERROR";
    AlertTypes["INFO"] = "INFO";
    AlertTypes["ERROR"] = "ERROR";
    AlertTypes["SYSTEM_ERROR"] = "SYSTEM_ERROR";
})(AlertTypes = exports.AlertTypes || (exports.AlertTypes = {}));
var CartActions;
(function (CartActions) {
    CartActions["ACCESSORY_ADDED"] = "ACCESSORY_ADDED";
    CartActions["ACCESSORY_UPDATE"] = "ACCESSORY_UPDATE";
    CartActions["ACCESSORY_REMOVED"] = "ACCESSORY_REMOVED";
    CartActions["DEVICE_ADDED"] = "DEVICE_ADDED";
    CartActions["DEVICE_UPDATE"] = "DEVICE_UPDATE";
    CartActions["DEVICE_REMOVED"] = "DEVICE_REMOVED";
    CartActions["DEVICE_ONCONFLICT"] = "DEVICE_ONCONFLICT";
    CartActions["DEVICE_INCREMENT"] = "DEVICE_INCREMENT";
    CartActions["DEVICE_DECREMENT"] = "DEVICE_DECREMENT";
    CartActions["ADD"] = "ADD";
    CartActions["REMOVE"] = "REMOVE";
    CartActions["UPDATE"] = "UPDATE";
    CartActions["PLAN_ADDED"] = "PLAN_ADDED";
    CartActions["PLAN_UPDATE"] = "PLAN_UPDATE";
    CartActions["PLAN_UPDATE_ONCONFLICT"] = "PLAN_UPDATE_ONCONFLICT";
    CartActions["INSURANCE_ADDED"] = "INSURANCE_ADDED";
    CartActions["INSURANCE_UPDATE"] = "INSURANCE_UPDATE";
    CartActions["INSURANCE_REMOVED"] = "INSURANCE_REMOVED";
})(CartActions = exports.CartActions || (exports.CartActions = {}));
var SalesStatus;
(function (SalesStatus) {
    SalesStatus["BUYNOW"] = "BUYNOW";
    SalesStatus["COMINGSOON"] = "COMINGSOON";
    SalesStatus["PREORDER"] = "PREORDER";
    SalesStatus["PREPREORDER"] = "PREPREORDER";
})(SalesStatus = exports.SalesStatus || (exports.SalesStatus = {}));
//  these three are SharedDataGroup Unlimites Codes as on 8/11/2020
//  SDGUNMAX /SDGINPRM /UNLTSDG
var PlanTypes;
(function (PlanTypes) {
    PlanTypes["PREPAID_PLAN"] = "PREPAIDPLAN";
    PlanTypes["SHARED_DATA_GROUP"] = "SHAREDDATAGROUP";
    PlanTypes["DATA_PLAN"] = "DATAPLAN";
    PlanTypes["VOICE_PLAN"] = "VOICEPLAN";
    PlanTypes["UNLIMITED_SOC_CD_1"] = "SDGUN";
    PlanTypes["UNLIMITED_SOC_CD_2"] = "SDGIN";
    PlanTypes["UNLIMITED_SOC_CD_3"] = "UNL";
})(PlanTypes = exports.PlanTypes || (exports.PlanTypes = {}));
var PlanFrequency;
(function (PlanFrequency) {
    PlanFrequency["MONTLY"] = "Monthly";
})(PlanFrequency = exports.PlanFrequency || (exports.PlanFrequency = {}));
//# sourceMappingURL=WirelessConstants.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/wireless-ui/api/WirelessConstants.js
// module id = 426
// module chunks = 8